// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: "fake-backend",
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "",
  },
  //apiUrl: "https://api.flowsales.com.br/api", // API principal do FlowSales
  apiUrl: "https://localhost:44393/api", // API principal do FlowSales
  //apiUrl: "https://hn3f2mtq-44393.brs.devtunnels.ms/api", // API principal do FlowSales
  whatsappApiUrl: "http://localhost:3000", // API do WhatsApp
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
